import styled from "styled-components";
import { Button, Input, Form } from "global/styles/styles.js";
const S = {};

const ProlongSessionWrapperBackgroundColor = ({theme: { $prolongSessionWrapperBackgroundColor }}) => `${$prolongSessionWrapperBackgroundColor}`;
const ProlongSessionWrapperTextColor = ({theme: { $prolongSessionWrapperTextColor }}) => `${$prolongSessionWrapperTextColor}`;
const ProlongSessionTopRowBackgroundColor = ({theme: { $prolongSessionTopRowBackgroundColor }}) => `${$prolongSessionTopRowBackgroundColor}`;
const ProlongSessionTopRowDistinctiveTextColor = ({theme: { $prolongSessionTopRowDistinctiveTextColor }}) => `${$prolongSessionTopRowDistinctiveTextColor}`;
const ProlongSessionMainMessageTextColor = ({theme: { $prolongSessionMainMessageTextColor }}) => `${$prolongSessionMainMessageTextColor}`;

const ProlongSessionBalanceLabelColorText = ({ theme: { $prolongSessionBalanceLabelColorText } }) => `${$prolongSessionBalanceLabelColorText}`;
const ProlongSessionBalanceBackgroundColor = ({ theme: { $prolongSessionBalanceBackgroundColor } }) => `${$prolongSessionBalanceBackgroundColor}`;
const ProlongSessionBalanceTextColor = ({ theme: { $prolongSessionBalanceTextColor } }) => `${$prolongSessionBalanceTextColor}`;

const ProlongSessionButtonsContainerBorderColor = ({theme: { $prolongSessionButtonsContainerBorderColor }}) => `${$prolongSessionButtonsContainerBorderColor}`;
const ProlongSessionButtonTextColor = ({ theme: { $prolongSessionButtonTextColor } }) => `${$prolongSessionButtonTextColor}`;
const SessionContinueButtonBackgroundColor = ({theme: { $sessionContinueButtonBackgroundColor }}) => `${$sessionContinueButtonBackgroundColor}`;
const ProlongSessionLeaveButtonBackgroundColor = ({theme: { $prolongSessionLeaveButtonBackgroundColor }}) => `${$prolongSessionLeaveButtonBackgroundColor}`;
const ProlongSessionReLoginButtonBackgroundColor = ({theme: { $prolongSessionReLoginButtonBackgroundColor }}) => `${$prolongSessionReLoginButtonBackgroundColor}`;
const ProlongSessionConfirmButtonBackgroundColor = ({theme: { $prolongSessionConfirmButtonBackgroundColor }}) => `${$prolongSessionConfirmButtonBackgroundColor}`;

const ErrorTextColor = ({theme: { $prolongSessionErrorTextColor }}) => `${$prolongSessionErrorTextColor}`;

const ProlongSessionInputBackgroundColor = ({theme: { $prolongSessionInputBackgroundColor }}) => `${$prolongSessionInputBackgroundColor}`;
const ProlongSessionInputTextColor = ({theme: { $prolongSessionInputTextColor}}) => `${$prolongSessionInputTextColor}`;
const ProlongSessionInputBorderColor = ({theme: { $prolongSessionInputBorderColor}}) => `${$prolongSessionInputBorderColor}`;

const ProlongSessionCounterTextColor = ({theme: { $prolongSessionCounterTextColor }}) => `${$prolongSessionCounterTextColor}`;

S.SendSmsCodeForm = styled(Form)`
  width: 100%;
  overflow: hidden;
`;

S.MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

S.ProlongSessionWrapper = styled.div`
  width: calc(100%-2px);
  display: flex;
  padding: 1rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${ProlongSessionWrapperBackgroundColor};
  color: ${ProlongSessionWrapperTextColor};
  border-bottom-right-radius: 0.42rem;
  border-bottom-left-radius: 0.42rem;

  &.padding-top {
    padding-top: 4rem;
  }
`;

S.TimerIcon = styled.div`
  width: calc(25px);
  height: calc(25px);
  margin-top: 1rem;
  margin-bottom: 2rem;
`;

S.ProlongSessionTopRow = styled.div`
  background-color: ${ProlongSessionTopRowBackgroundColor};
  padding: 0.5rem 1.5rem 0.5rem 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 0.9rem;
  gap: 0.5rem;
`;

S.TopRowLeftSide = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center
`;

S.TopRowRightSide = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center
`;

S.SessionDeactive = styled.span`
  text-transform: uppercase;
  font-weight: 600;
`;

S.ProlongSessionUserDetails = styled.span`
  color: ${ProlongSessionTopRowDistinctiveTextColor};
  text-transform: uppercase;
  font-weight: 600;
`;

S.ProlongSessionUserMobile = styled.span`
  color: ${ProlongSessionTopRowDistinctiveTextColor};
  text-transform: none;
  font-weight: 600;
`;

S.ProlongSessionHighlightedMessage = styled.div`
  font-size: 16px;
  font-weight: 600;
  text-align: center;
`;

S.ProlongSessionMainMessage = styled.div`
  margin-top: 2rem;
  margin-bottom: 3rem;
  text-align: center;
  padding: 0 25% 0 25%;
  font-size: 14px;
  color: ${ProlongSessionMainMessageTextColor};
`;

S.ButtonsTopBorder = styled.div`
  background-color: ${ProlongSessionButtonsContainerBorderColor};
  opacity: 0.3;
  width: 100%;
  height: 1px;
`;

S.ButtonsContainer = styled.div`
  width: 100%;
  padding-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: space-between;
`;

S.ButtonAction = styled(Button)`
  border: 0px;
  border-radius: 20px;
  height: 2.5rem;
  line-height: 2.5rem;
  width: 100%;
  color: ${ProlongSessionButtonTextColor};
  text-transform: uppercase;
  font-size: 14px;
  text-align: center;

  &.continue {
    background-color: ${SessionContinueButtonBackgroundColor};
  }

  &.leave {
    background-color: ${ProlongSessionLeaveButtonBackgroundColor};
  }

  &.reLogin {
    background-color: ${ProlongSessionReLoginButtonBackgroundColor};
  }

  &.confirm {
    background-color: ${ProlongSessionConfirmButtonBackgroundColor};
    margin-left: auto;
  }
`;

S.BalanceLabel = styled.span`
  color: ${ProlongSessionBalanceLabelColorText};
  text-transform: uppercase;
  margin-right: 1rem;
  font-weight: 600; 
`;

S.BalanceBackground = styled.div`
  width: 9.5rem;
  height: 2rem;
  line-height: 2rem;
  text-align: right;
  padding-right: 0.5rem;
  border-radius: 4px;
  background-color: ${ProlongSessionBalanceBackgroundColor};
  color: ${ProlongSessionBalanceTextColor};
`;

S.ProlongSessionPutSmsCodeMessage = styled.div`
  margin-top: 2rem;
  margin-bottom: 1rem;
  text-align: center;
  padding: 0 5% 0 5%;
  font-size: 14px;
  color: ${ProlongSessionMainMessageTextColor};
`;

S.InputContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 2rem;
`;

S.InputWrapper = styled.div`
  width: 60%;
  display: flex;
  margin-left: auto;
  flex-direction: column;
`;

S.SmsCodeInput = styled(Input)`
    font-size: 17px;
    font-weight: bold;
    text-align: right;
    padding: 0.5rem 1rem 0.5rem 1rem;
    background-color: ${ProlongSessionInputBackgroundColor};
    color: ${ProlongSessionInputTextColor};
    border: 1px solid ${ProlongSessionInputBorderColor};
`;

S.ErrorMessage = styled.div`
  text-align: right;
  color: ${ErrorTextColor};
  font-size: 12px;
`;

S.SendAgainContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`;

S.Counter = styled.div`
  font-size: 2rem;
  color: ${ProlongSessionCounterTextColor};
  margin-left: auto;
  &.visibility-hidden {
    visibility: hidden;
  }
`;

S.ResendSmsCode = styled(Button)`
    width: 9.5rem;
    height: 2rem;
    line-height: 2rem;
    text-align: right;
    padding-right: 0.5rem;
    border-radius: 4px;
    background-color: ${ProlongSessionBalanceBackgroundColor};
    color: ${ProlongSessionBalanceTextColor};
    margin-left: 1rem;
    margin-top: 5px;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 13px;
    text-align: center;
    opacity: 1.0;
    &[disabled]{
      opacity: 0.1;
    }
`;



export default S;
